import image1 from '../../assets/home/1.png'
import image1a from '../../assets/home/1a.jpg'
import image2 from '../../assets/home/2.jpg'
import image2a from '../../assets/home/2a.jpg'
import image3 from '../../assets/home/3.jpg'
import image3a from '../../assets/home/3a.jpg'
import image4 from '../../assets/home/4.jpg'
import image4a from '../../assets/home/4a.jpg'
import image5 from '../../assets/home/5.jpg'
import image5a from '../../assets/home/5a.jpg'
import image6 from '../../assets/home/6.jpg'
import image6a from '../../assets/home/6a.jpg'
import image7 from '../../assets/home/7.jpg'
import image7a from '../../assets/home/7a.jpg'
import image8 from '../../assets/home/8.jpg'
import image8a from '../../assets/home/8a.jpg'
import image9 from '../../assets/home/9.png'
import image9a from '../../assets/home/9a.jpg'
import image10 from '../../assets/home/10.jpg'
import image10a from '../../assets/home/10a.jpg'
import image11 from '../../assets/home/11.jpg'
import image11a from '../../assets/home/11a.jpg'
import image12 from '../../assets/home/12.jpg'
import image12a from '../../assets/home/12a.jpg'
import image13 from '../../assets/home/13.png'
import image13a from '../../assets/home/13a.jpg'
import image14 from '../../assets/home/14.jpg'
import image14a from '../../assets/home/14a.jpg'
import image15 from '../../assets/home/15.jpg'
import image15a from '../../assets/home/15a.jpg'


const INITIAL_STATE = {

sliderData: [{
    game: "Free Fire",
    name: "Garena Kings Showdown",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Are you up to the challenge?? Then show your mettle!!",
    date: "Feb 27, 2021",
    image: image1,
    image1:image1a

},
{
    game: "Fifa Soccer",
    name: "Gamezone Fifa Soccer Tournament",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Are you up to the challenge?? Then show your mettle!!",
    date: "Feb 27, 2021",
    image: image2,
    image1:image2a

},
{
    game: "Need For Speed",
    name: "NFS Wanted Rivals",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Are you up to the challenge?? Then show your mettle!!",
    date: "Feb 27, 2021",
    image: image3,
    image1: image3a

},
{
    game: "Tekken",
    name: "Tekken Tournament",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Are your fists made of iron?? Be the last man standing",
    date: "Feb 27, 2021",
    image: image4,
    image1: image4a

},
{
    game: "Mortal Kombat",
    name: "Mortal Kombat Immortals Unleashed",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Are you up to the challenge?? Then show your mettle!!",
    date: "Feb 27, 2021",
    image: image5,
    image1: image5a

},
{
    game: "Street Fighter",
    name: "Hadoken Showdown",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "This is the streets!! Are you up to the challenge?? Then show your mettle!!",
    date: "Feb 27, 2021",
    image: image6,
    image1: image6a

},
{
    game: "Call of Duty",
    name: "COD Spoils of War",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "You have been called to duty. Are you up to the challenge?? Then show your mettle!!",
    date: "Feb 27, 2021",
    image: image7,
    image1: image7a

},
{
    game: "Halo",
    name: "Halo Survival",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Let's see how bright your halo burns. ",
    date: "Feb 27, 2021",
    image: image8,
    image1: image8a

},
{
    game: "Jump Force",
    name: "Jump Force Unleashed",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Wield your sword and show us how it slices",
    date: "Feb 27, 2021",
    image: image9,
    image1: image9a

},
{
    game: "Dota 2",
    name: "Dota 2 Championship",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Are you a dot in this universe??? Or you wanna prove us wrong",
    date: "Feb 27, 2021",
    image: image10,
    image1: image10a

},
{

    game: "PUGB",
    name: "PUGB Shiiiiii",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "A purge to bring out the best",
    date: "Feb 27, 2021",
    image: image11,
    image1: image11a

},
{
    game: "Fortnite",
    name: "Fortnite Alliance",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Knights would come out of this",
    date: "Feb 27, 2021",
    image: image12,
    image1: image12a

},
{
    game: "Counter Strike",
    name: "Counter Strike League",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "You got what it takes to be part of the elite strike force team??",
    date: "Feb 27, 2021",
    image: image13,
    image1: image13a

},
{
    game:"League of Legends",
    name: "League of Legends Extreme Survival",
    uid: null,
    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Are you up to the challenge?? Then show your mettle!!",
    date: "Feb 27, 2021",
    image: image14,
    image1: image14a

},
{
    game: "PES",
    name:"PES 2021 World Cup",
    uid: null,

    rules: ["All Competitions Must Be Subscribed for", "Do not participate after elimination", "May the best gamer win!!!"],
    description: "Are you up to the challenge?? Then show your mettle!! ",
    date: "Feb 27, 2021",
    image: image15,
    image1: image15a

}]

};


const homePageSliderReducer=(state=INITIAL_STATE, action)=>{
    switch(action.type){
        default:    return  state;

    }
}


export  default homePageSliderReducer;